import type { PlainMessage } from "@bufbuild/protobuf";
import type { EnvironmentGitStatus } from "gitpod-next-api/gitpod/v1/environment_pb";
import { pluralize } from "@/utils/strings";

export function gitStatusChangesCount(git?: PlainMessage<EnvironmentGitStatus>): number | null {
    if (!git) {
        return null;
    }
    return (git?.totalUnpushedCommits || 0) + (git?.totalChangedFiles || 0);
}

export function formatChangesCount(count: number, options?: { includeLabel?: boolean }): string {
    const hasMore = count > 99;
    const num = hasMore ? "99" : `${count}`;
    const displayCount = hasMore ? 99 : count;
    if (options?.includeLabel) {
        return `${hasMore ? "+" : ""}${num} ${pluralize(displayCount, "change")}`;
    }
    return `${hasMore ? "+" : ""}${num}`;
}

export function gitStatusLabel(git?: PlainMessage<EnvironmentGitStatus>): string | null {
    if (!git) {
        return null;
    }

    const changes = gitStatusChangesCount(git) ?? 0;
    if (changes === 0) {
        return "No changes";
    }
    return `${changes} change${changes > 1 ? "s" : ""}`;
}
